import { render, staticRenderFns } from "./ktojindex_A.vue?vue&type=template&id=28bf562c&scoped=true&"
import script from "./ktojindex_A.vue?vue&type=script&lang=js&"
export * from "./ktojindex_A.vue?vue&type=script&lang=js&"
import style0 from "./ktojindex_A.vue?vue&type=style&index=0&id=28bf562c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf562c",
  null
  
)

export default component.exports